<script lang="ts">
	import { format } from 'svelte-i18n';
	import ImageList from '../../../Lists/ImageList.svelte';
	import { Text, Input, Container } from '@Shelly/shelly-design-system';
	import { getImages, getImagesByType } from '../../../Lists/list-helpers';
	import { capFirstChar, _deepClone } from '../../../../helpers/utilities';

	export let alarm_object = {};

	// $: name = alarm_object?._meta?.name.trim() || '';
	let uploadedImagesDB = [];
	let imagesBySceneType = [];

	let selectedImage = alarm_object?._meta?.image || '';
	let selectedBackgroundColor = alarm_object?._meta?.backgroundColor || '';
	let inputRef: HTMLElement;
	let inputDirty = false;

	const requestType = 'alarm';

	const downloadImages = async () => {
		uploadedImagesDB = await getImages(requestType);
		imagesBySceneType = await getImagesByType(requestType, null);
	};

	// Image List Functions - on images actions
	const onSelectImage = (e: CustomEvent) => {
		// let _copy_alarm: any = _deepClone($alarm_object);
		// _copy_alarm._meta.image = e?.detail?.image;
		// alarm_object.change(_copy_alarm);
		alarm_object._meta.image = e?.detail?.image || '';
		alarm_object._meta.backgroundColor = e?.detail?.backgroundColor || '';
	};

	const onUploadImage = (e: CustomEvent) => {
		// console.log('UPLOADED IMAGE', e.detail);
		onSelectImage(e);
		uploadedImagesDB = [...e.detail.uploadedImagesDB];
	};

	const onInput = (e) => {
		if (!inputDirty) inputDirty = true;

		let _copy_alarm: any = _deepClone(alarm_object);
		alarm_object._meta.name = e.target.value;
		// if there is no set alarm message we create a default one from alarm zone name and default text Motion detected
		// if the name of the alarm is a part of the alarm message, on any change of name we change the message

		// @ToDo: Need to clarify the new UX
		// if (
		// 	_copy_alarm?.do?.[0].do.blk[0]?.msg === '' ||
		// 	_copy_alarm?.do?.[0].do.blk[0]?.msg.match(_copy_alarm?._meta?.name)
		// ) {
		// 	alarm_object.do[0].do.blk[0].msg = `${alarm_object?._meta?.name}: Motion detected!`;
		// 	console.log('update message ', _copy_alarm.do?.[0].do.blk[0]?.msg);
		// }
	};
</script>

<Container noScroll padding="scrollPaddings">
	<Text element="h2" class="mb-s">
		{capFirstChar(
			$format('placeholder_name', {
				values: { type: $format('process_alarm') },
			}),
		)}</Text
	>
	<Input
		id="input-name"
		aria-labelledby="input-name"
		icon="fas fa-shield-halved"
		label={$format('label_name', { default: 'Name' })}
		value={alarm_object?._meta?.name || ''}
		error={alarm_object?._meta?.name === '' && inputDirty
			? $format('input_error_empty_name', {
					default: 'Name cannot be empty',
				})
			: ''}
		bind:ref={inputRef}
		on:input={onInput}
	/>
	<hr class="mb-l mt-l" />
</Container>

<Container noScroll padding="scrollPaddings">
	<Text element="h2" class="mb-m">
		{capFirstChar($format('select_picture', { default: 'Select picture' }))}
	</Text>
	{#await downloadImages() then res}
		<ImageList
			{uploadedImagesDB}
			imagesByTypeDB={imagesBySceneType}
			{selectedImage}
			{selectedBackgroundColor}
			setDefaultImage={selectedImage === '' && !selectedBackgroundColor}
			requestType={'alarm'}
			on:select-image={onSelectImage}
			on:upload-image={onUploadImage}
		/>
	{/await}
</Container>
